import React from 'react';
import styled from 'styled-components/macro';
import ListItemV2 from './ListItemV2';

export const ListCardItemHolderDesktop = ({
  details,
  isMobile,
  isChild,
  parent,
  isToday,
}) => {
  return (
    <ListCardItemHolder>
      <ListCardItemGrid>
        <ListItemV2
          details={details}
          isMobile={isMobile}
          isChild={isChild}
          parent={parent}
          isToday={isToday}
        />
      </ListCardItemGrid>
    </ListCardItemHolder>
  );
};

const ListCardItemGrid = styled.div`
  display: block;
`;

const ListCardItemHolder = styled.div`
  border-radius: 6px;
  margin-bottom: 12px;
  min-height: 35px;
  padding-bottom: 12px;
  position: relative;
  z-index: 5;
  a:hover {
    h3,
    h4 {
      color: ${(props) =>
        props.theme.name === 'light'
          ? `${props.theme.color.primaryAA}`
          : `${props.theme.color.primaryFull}`};
      transition: all 0.3s linear;
    }
  }
  a:focus-visible {
    outline: none;
    > div {
      outline: 4px solid
        ${(props) =>
          props.theme.name === 'light'
            ? `${props.theme.color.statusLightFocus}`
            : `${props.theme.color.statusDarkFocus}`};
      border-radius: 8px;
      outline-offset: 4px;
    }
  }
`;
